import { apiRequest } from "./apiClient";

export type PumpRechargeRequestStatus = "PENDING" | "APPROVED" | "REJECTED";

export type PumpRechargeRequest = {
  id: number;
  pumpId: number;
  pumpName: string;
  pumpCode?: string | null;
  zoneId?: number | null;
  zoneName?: string | null;
  amount: number;
  status: PumpRechargeRequestStatus;
  requestedAt: string;
  requestedBy?: number | {
    id: number;
    name?: string | null;
    surname?: string | null;
  } | null;
  requestedByUser?: {
    id: number;
    name?: string | null;
    surname?: string | null;
  } | null;
  requestedByName?: string | null;
  approvedAt?: string | null;
  approvedBy?: number | {
    id: number;
    name?: string | null;
    surname?: string | null;
  } | null;
  approvedByUser?: {
    id: number;
    name?: string | null;
    surname?: string | null;
  } | null;
  approvedByName?: string | null;
  notes?: string | null;
  decisionNotes?: string | null;
  reference?: string | null;
};

export type PumpRechargeRequestListResponse = {
  items: PumpRechargeRequest[];
  meta: {
    page: number;
    pageSize: number;
    total: number;
    pages: number;
  };
};

export type FetchPumpRechargeRequestOptions = {
  page?: number;
  pageSize?: number;
  status?: PumpRechargeRequestStatus;
  signal?: AbortSignal;
};

export type PumpRechargeRequestPayload = {
  amount: number;
  reference?: string | null;
  notes?: string | null;
};

export type PumpRechargeApprovalPayload = {
  notes?: string | null;
};

const buildQuery = (options?: FetchPumpRechargeRequestOptions) => {
  if (!options) {
    return "";
  }

  const params = new URLSearchParams();
  if (options.page && options.page > 0) {
    params.append("page", String(options.page));
  }
  if (options.pageSize && options.pageSize > 0) {
    params.append("pageSize", String(options.pageSize));
  }
  if (options.status) {
    params.append("status", options.status);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};

export function fetchPumpRechargeRequests(options?: FetchPumpRechargeRequestOptions) {
  const query = buildQuery(options);
  return apiRequest<PumpRechargeRequestListResponse>(`/api/pumps/recharge-requests${query}`, {
    signal: options?.signal,
  });
}

export function createPumpRechargeRequest(
  pumpId: number | string,
  payload: PumpRechargeRequestPayload
) {
  return apiRequest<PumpRechargeRequest>(`/api/pumps/${pumpId}/recharge-requests`, {
    method: "POST",
    body: payload,
  });
}

export function approvePumpRechargeRequest(
  requestId: number | string,
  payload?: PumpRechargeApprovalPayload
) {
  return apiRequest<PumpRechargeRequest>(`/api/pumps/recharge-requests/${requestId}/approve`, {
    method: "POST",
    body: payload,
  });
}

export function rejectPumpRechargeRequest(
  requestId: number | string,
  payload?: PumpRechargeApprovalPayload
) {
  return apiRequest<PumpRechargeRequest>(`/api/pumps/recharge-requests/${requestId}/reject`, {
    method: "POST",
    body: payload,
  });
}
